import React, { useEffect, useMemo, useState } from 'react';
import { Checkbox, TextField, Button, Box, InputAdornment } from '@mui/material';
import { Search } from '@mui/icons-material';
import CollapsedProductsTable from './CollapsedProductsTable';

function InvoiceProductReview({ details, setDetails, onSave, setOpen, invoice, setInvoice }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(searchTerm), 280);
    return () => clearTimeout(t);
  }, [searchTerm]);

  const handleCheckbox = (productId, isChecked) => {
    setDetails(prev => prev.map(item =>
      (item.product === productId || item.product_id === productId)
        ? { ...item, checked: isChecked, quantityRe: isChecked ? item.quantity : '' }
        : item
    ));
  };

  const handleQuantityChange = (productId, value) => {
    setDetails(prev => prev.map(item => {
      if (item.product === productId || item.product_id === productId) {
        const max = item.quantity;
        const qty = value === '' ? '' : Math.min(value, max);
        return { ...item, quantityRe: qty };
      }
      return item;
    }));
  };

  const columns = [
    {
      key: 'selection',
      label: 'Revisado',
      render: row => (
        <Checkbox
          checked={!!row.checked}
          onChange={e => handleCheckbox(row.product || row.product_id, e.target.checked)}
          color="primary"
        />
      )
    },
    {
      key: 'code',
      label: 'Código',
      render: row => row.product?.code || '—'
    },

    {
      key: 'description',
      label: 'Descripción',
      render: row => row.product?.description || '—'
    },
    { key: 'quantity', label: 'Cantidad', align: 'right' },
    {
      key: 'prformat',
      label: 'Formato',
      align: 'right',
      render: row => row?.prformat?.name || row?.prformat || '—'
    },
    {
      key: 'quantityRe',
      label: 'Cantidad recibida',
      align: 'right',
      render: row => (
        !row.checked ? (
          <TextField
            type="text"
            value={row.quantityRe?.toString() || ''}
            size="small"
            onChange={e => {
              const val = e.target.value;
              if (/^\d*$/.test(val)) {
                handleQuantityChange(row.product || row.product_id, val === '' ? '' : parseInt(val, 10));
              }
            }}
            onBlur={e => {
              const val = e.target.value;
              const parsed = parseInt(val, 10);
              if (!isNaN(parsed)) {
                handleQuantityChange(row.product || row.product_id, Math.min(parsed, row.quantity));
              }
            }}
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            sx={{ width: 90 }}
          />
        ) : (
          row.quantityRe
        )
      )
    }
  ];
useEffect(() => {
console.log('detalle: ',details)

}, [details]);
  const summary = useMemo(() => {
    let subTotal = 0;
    let descuentoProductoNoEntregado = 0;
    details.forEach(item => {
      const qty = parseInt(item.quantity) || 0;
      const qtyRe = parseInt(item.quantityRe) || 0;
      const price = parseFloat(item.finalPrice || item.price) || 0;
      subTotal += qty * price;
      descuentoProductoNoEntregado += (qty - qtyRe) * price;
    });
    return {
      subTotal,
      descuentoProductoNoEntregado,
      total: subTotal - descuentoProductoNoEntregado,
      labelTotal: 'Total a pagar',
    };
  }, [details]);

  const filteredDetails = useMemo(() => {
    const term = String(debouncedSearch || '').trim().toLowerCase();
    if (!term) return details || [];
    return (details || []).filter((row) => {
      const code = String(row?.code ?? row?.product?.code ?? '').toLowerCase();
      const description = String(row?.description ?? row?.product?.description ?? '').toLowerCase();
      return code.includes(term) || description.includes(term);
    });
  }, [details, debouncedSearch]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <TextField
        size="small"
        placeholder="Buscar por código o descripción..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      <CollapsedProductsTable
        data={filteredDetails}
        columns={columns}
        pagination={true}
        rowsPerPage={5}
        summary={summary}

      />
      <Button
        variant="contained"
        onClick={() => {
          onSave && onSave();
          setOpen(false);
        }}
        sx={{ alignSelf: 'flex-end' }}
      >
        Guardar
      </Button>
    </Box>
  );
}

export default InvoiceProductReview;
